import SingleStudentAssignmentView from "@features/assignments/SingleStudentAssignment/view";

const SingleStudentAssignment = () => {
  return <SingleStudentAssignmentView />;
};

export default SingleStudentAssignment;
